export default {
    behavior_clearFilters: 'Clear filters',
    behavior_clearAll: 'Clear all',
}
